import Bullet from '../../Entity/Bullet.js'
import Vector from '../../Vector.js'
import Size from '../../Size.js'

export const TYPE_BULLET_DESTROYED = 'bullet_destroyed'

class BulletDestroyed {
    
    constructor(data) {
        this.data = data
    }
    
    handle(game) {
        const data = this.data;
        const bullets = game.getBullets();
        if(bullets.hasId(data.id)) {
            bullets.getById(data.id).destroy();
        }
    }
    
}

export default BulletDestroyed
